export const jurosCorrecaoFields = (jurosOptions = {}) => [
    { key: "indexadorCorrecaoPercentual", label: "Indexador Correção Percentual", required: true, maskType: "decimal", md: 4 },
    { key: "defasagem", label: "Defasagem", required: true, type: "number", maskType: "integer",inputProps: { step: "1" }, defaultValue: 0 },
    {
        key: "calculoDiasIndexador",
        label: "Cálculo Dias Indexador",
        required: true,
        type: "select",
        md: 4,
        defaultValue: "Uteis",
        options: [
            { value: "Uteis", label: "Uteis" },
            { value: "Corridos", label: "Corridos" },
            { value: "Corridos360", label: "Corridos360" },
            { value: "Corridos360E", label: "Corridos360E" },
        ]
    },
    { key: "formulaIndexador", label: "Fórmula Indexador", required: true, md: 4, defaultValue: null },
    {
        key: "calculoDias",
        label: "Cálculo Dias",
        required: true,
        type: "select",
        md: 4,
        defaultValue: "Uteis",
        options: (jurosOptions.CalculoDias || []).map(x => ({
            value: x,
            label: x
        }))
    },
    {
        key: "jurosCapitalizacao",
        label: "Juros Capitalização",
        required: true,
        type: "select",
        md: 4,
        defaultValue: "d.u./252 Cmp",
        options: (jurosOptions.JurosCapitalizacao || []).map(x => ({
            value: x,
            label: x
        }))
    },
    { 
        key: "periodicidadeAtualizacaoMonetaria", 
        label: "Periodicidade Atualização Monetária", 
        type: "select", 
        options: [
            { value: 1, label: "Diária" },
            { value: 2, label: "Mensal" },
            { value: 3, label: "Trimestral" },
            { value: 4, label: "Semestral" },
            { value: 5, label: "Anual" },
            { value: 6, label: "Não tem" },
        ],
        md: 4, 
        defaultValue: 6 
    },
    { key: "mesAniversarioAnualSemestral", label: "Mês Aniversário Anual Semestral", md: 4, defaultValue: null },
    { key: "projecaoInflacao", label: "Projeção Inflação", md: 4, type: "select", options: [{ value: 0, label: "0" }, { value: 1, label: "1" },], defaultValue: 0 },
    { key: "inflacaoNegativa", label: "Inflação Negativa", type: "select", options: [{ value: 0, label: "0" }, { value: 1, label: "1" }], md: 4, defaultValue: 0 },
    { key: "recalculoProjecao", label: "Recálculo Projeção", type: "select", options: [{ value: 0, label: "0" }, { value: 1, label: "1" }], md: 4, defaultValue: 0 },
    { 
        key: "aplicacaoAmortizacao", 
        label: "Aplicação Amortização", 
        required: true, 
        md: 4, 
        type: "select",
        defaultValue: "VNI",
        options: [
            { value: "VNI", label: "VNI" },
            { value: "VNA", label: "VNA" },
            { value: "VNAI", label: "VNAI" },
        ]
    },
    { 
        key: "corrigeDataEvento", 
        label: "Corrige Data Evento", 
        type: "select",
        required: true, 
        md: 4, 
        defaultValue: "NaoCorrige",
        options: [
            { value: "NaoCorrige", label: "Não Corrige" },
            { value: "ProximoDiaUtil", label: "Próximo Dia Util" },
            { value: "DiaUtilAnterior", label: "Dia Útil Anterior" },
        ]
    },
]